import { AppCommonsModule } from '../../app-commons.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { KYMW0003Component } from './kymw0003.component';
import { GetPlanSupportCompanyInfoService } from './api-services/get-plan-support-company-info.service';

/**
 * 企画支援選択画面 モジュール設定クラス
 *
 * @export KYMW0003Module
 * @class KYMW0003Module
 */
@NgModule({
  imports: [
    AppCommonsModule,
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0003Component,
  ],
  providers: [
    GetPlanSupportCompanyInfoService,
  ],
})
export class KYMW0003Module { }
